import React from 'react';
import { navigation } from '@ecosystem/newron-design-system';
import { AccessTags, PageTags } from '../analytics';
import { useContentAnalytics } from './analytics';

type Props = {
  dark?: boolean;
  version?: string;
  pageName?: string;
  getTrackingTags?: () => Partial<AccessTags & PageTags>;
};

function ClientFooter({ dark = false, version, pageName, getTrackingTags }: Props) {
  const { Footer } = navigation;
  const { trackFooterElementClicked } = useContentAnalytics();
  const footerAnalytics = async (page: string) => {
    trackFooterElementClicked({ page, pageName, getTrackingTags });
  };

  const openCookieSettings = () => {
    (window as any)?.Optanon?.ToggleInfoDisplay();
  };

  return (
    <Footer version={version} dark={dark}>
      <Footer.Link
        testId="cookie-settings-footer"
        onClick={() => {
          footerAnalytics('Cookie Settings');
          openCookieSettings();
        }}
      >
        Cookie Settings
      </Footer.Link>
      <Footer.Link
        testId="support-footer"
        target="https://helpcenter.gfk.com/"
        onClick={() => {
          footerAnalytics('Help Center');
        }}
      >
        Help Center
      </Footer.Link>
      <Footer.Link
        testId="acceptable-use-policy"
        target="/acceptable-use-policy"
        onClick={() => {
          footerAnalytics('Acceptable Use Policy');
        }}
      >
        Acceptable Use Policy
      </Footer.Link>
      <Footer.Link
        testId="terms-and-conditions"
        target="/terms-and-conditions"
        onClick={() => {
          footerAnalytics('Beta Terms & Conditions');
        }}
      >
        Beta Terms & Conditions
      </Footer.Link>
      <Footer.Link
        testId="privacy-policy"
        target="https://nielseniq.com/global/en/legal/privacy-notice-for-gfknewron/"
        onClick={() => {
          footerAnalytics('Privacy Policy');
        }}
      >
        Privacy Policy
      </Footer.Link>
    </Footer>
  );
}

export { ClientFooter };
